import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=bf664114&"
import script from "./Accounts.vue?vue&type=script&lang=js&"
export * from "./Accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf664114')) {
      api.createRecord('bf664114', component.options)
    } else {
      api.reload('bf664114', component.options)
    }
    module.hot.accept("./Accounts.vue?vue&type=template&id=bf664114&", function () {
      api.rerender('bf664114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/Accounts.vue"
export default component.exports